import React from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';

export enum AuthFlow {
  SIGN_IN = 'sign-in',
  CLINICIAN_SIGN_UP = 'clinician-sign-up',
  PATIENT_SIGN_UP = 'patient-sign-up',
}

export enum AuthStep {
  EMAIL = 'email',
  PHONE = 'phone',
  PIN = 'pin',
  PHONE_CODE = 'phone-code',
  EMAIL_CODE = 'email-code',
  DETAILS = 'details',
  COMPLETE = 'complete',
}

export interface AuthStateType {
  tempPass?: string;
  login_type?: 'SMS' | 'PIN' | null;
  pin?: string;
  phone_code?: string;
  email_verified?: boolean;
  email?: string;
  phone?: string;
  cognitoUser?: CognitoUser | null;
  isRegistering?: boolean;
}

export interface SignInResponse {
  challengeParam?: {
    email?: string;
    login_type?: 'SMS' | 'PIN';
  };
  getSignInUserSession?: () => any;
}

export interface SignInFormProps {
  navigate?: (path: string) => void;
}

export interface AuthFieldProps {
  label: string;
  type: string;
  value?: string;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export interface PinToggleProps {
  label: string;
  type: string;
  autocomplete?: string;
  submit: (pin?: string) => void;
}

export interface CodeFormData {
  code?: string;
  phone?: string;
}

export interface CodeFormProps {
  onSubmit?: (data: CodeFormData) => void;
}

export type PhoneChangeHandler = (phone: string | undefined) => void;
export type PinUpdateHandler = (pin: string) => void;
export type FormSubmitHandler = (e: React.FormEvent<HTMLFormElement>) => void;

export interface NavigateFunction {
  (path: string): void;
}

export interface ComponentState {
  isLoading: boolean;
  showPin?: boolean;
  option?: 'currentPin' | 'forgotPassword';
}

export interface VerificationCodeProps {
  fields: number;
  onChange: (code: string) => void;
  value?: string;
  type?: 'text' | 'password';
  isValid?: boolean;
}
